const BODY_MEASUREMENT_FALLBACKS = {
  upper_seat_hip_circumference: ['lower_seat_hip_circumference'],
};

const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  return true;
};

export const getBodyMeasurementValue = (measurement, fieldKey) => {
  if (!measurement || !fieldKey) return null;
  const primary = measurement[fieldKey];
  if (hasValue(primary)) return primary;
  const fallbacks = BODY_MEASUREMENT_FALLBACKS[fieldKey] || [];
  for (const fallbackKey of fallbacks) {
    const fallbackValue = measurement[fallbackKey];
    if (hasValue(fallbackValue)) return fallbackValue;
  }
  return null;
};
